import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import AuthProviderWrapper from "./context/AuthProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthProviderWrapper>
    <App />
  </AuthProviderWrapper>
);